import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { IndexService } from 'digiteq-ai-portal-client-lib';
import { ErrorService } from '../../services/error.service';
import { combineLatest } from 'rxjs';
import { AiPortalApps } from '../../constants/aiPortalApps';
import { AiPortalItem } from '../../models/ai-portal-item';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent implements OnInit{
  isAuthenticated = false;
  aiPortalApps: AiPortalApps;

   constructor(
    private authService: AuthService,
    private indexService: IndexService,
    private errorService: ErrorService,
   ) {
     this.aiPortalApps = new AiPortalApps();
  }

  ngOnInit() {
    combineLatest([
      this.authService.isAuthenticated$,
      this.authService.currentUser$
    ]).subscribe(([isAuth, user]) => {
      this.isAuthenticated = isAuth;

      if (user) {
        this.aiPortalApps.aiPortalItems.forEach(item => {
          this.checkAccessRights(item);
        });

        if (this.authService.isInRoles(this.aiPortalApps.daise.canAccess)) {
          this.checkDaiseIndexes();
        }
      }
    });
   }

  private checkAccessRights(app: AiPortalItem) {
    if (!this.authService.isInRoles(app.canAccess)) {
      app.enabled = false;
      app.routerLink = '';
      app.description = 'You don\'t have right for this app...';
    } else {
      app.enabled = true;
    }
  }

  private checkDaiseIndexes() {
     this.indexService.getIndexes().subscribe({
        next: indexes => {
          if (indexes.length === 0) {
            this.aiPortalApps.daise.enabled = false;
            this.aiPortalApps.daise.description = 'No indexes found...';
          }
        },
        error: () => {
          this.aiPortalApps.daise.enabled = false;
          this.errorService.handleError( 'Error getting DAISE indexes', 'DAISE is disabled');
        },
     });
  }

}
